import LanguageManager from '../language_manager/language_manager';
import safe from '../../util/safe';
import DomUtils from '../../util/dom_utils';

const Browser = require('../browser/browser');

const template = require('./video_quality.hbs');

module.exports = (() => {
    let videoQualityElem = 'bitdash-settings';
    let videoQualityElemCustom = 'bitdash-settings--videoquality bitdash-settings-pane';
    let emitter;
    let boundLimit = 5e3;
    let qualityList = {
        'good': 601,
        'better': 1601,
        'best': 3501
    };
    let translationKeys = {
        'best': 'quality_type_high',
        'better': 'quality_type_medium',
        'good': 'quality_type_low'
    };

    return {
        render(html) {
            let containerElem = safe.code(() => document.getElementsByClassName(videoQualityElem)[0]);
            containerElem.parentNode.appendChild(this.buildTag('div', videoQualityElemCustom, html));

            return true;
        },
        
        modify(values, cb) {
            return values.map(cb).filter(x => x);
        },

        addDisplayLabel(item) {
            item.display_label = LanguageManager.get(translationKeys[item.quality]);
            item.quality_key = translationKeys[item.quality];

            const videoQualityVal = safe.code(() => sessionStorage.getItem('video-quality'));

            if (item.quality_key === videoQualityVal) {
                item.active = true;
            }

            return item;
        },
        
        uniqueEntries(entries) {
            const mappedEntries = {};
            const convertToKbps = (v) => Math.floor(v / 1000);
            entries.forEach((e, i) => {
                const bitrate = convertToKbps(e.bitrate);
                e.dim = e.label.split(',')[0];
                e.kbps = bitrate;
                if (bitrate <= qualityList.good) {
                    if (!mappedEntries.good || bitrate > mappedEntries.good.kbps) {
                        mappedEntries.good = e;
                    }
                } else if (bitrate <= qualityList.better) {
                    if (!mappedEntries.better || bitrate > mappedEntries.better.kbps) {
                        mappedEntries.better = e;
                    }
                } else if (bitrate <= qualityList.best) {
                    if (!mappedEntries.best || bitrate > mappedEntries.best.kbps) {
                        mappedEntries.best = e;
                    }
                }
                
            });

            mappedEntries.best = mappedEntries.best || mappedEntries.better || mappedEntries.good || entries[0];
            mappedEntries.better = mappedEntries.better || mappedEntries.best || mappedEntries.good;
            mappedEntries.good = mappedEntries.good || mappedEntries.better || mappedEntries.best;

            mappedEntries.best = {...mappedEntries.best || {}, quality: 'best'};
            mappedEntries.better = {...mappedEntries.better || {}, quality: 'better'};
            mappedEntries.good = {...mappedEntries.good || {}, quality: 'good'};

            return [mappedEntries.best, mappedEntries.better, mappedEntries.good];
        },

        uniqueEntriesOld(entries) {
            let mappedEntries = {};
            let uniqueEntries = [];

            const qualityKeys = Object.keys(qualityList);

            entries.forEach((e, i) => {
                for (let x = 0; x < qualityKeys.length; x++) {
                    if (e.label.indexOf(qualityKeys[x]) > -1) {
                        e.dim = qualityList[qualityKeys[x]];
                        break;
                    } else {
                        const diff = Math.abs(
                            (parseInt(qualityKeys[x]) * 1e3) - parseInt(e.bitrate)
                        ) < boundLimit;

                        if (diff) {
                            e.dim = qualityList[qualityKeys[x]];
                            break;
                        }
                    }
                }
                
                if (!e.dim) return false;

                mappedEntries[e.dim] = i;
            });

            Object.keys(mappedEntries).forEach(key => {
                const item = entries[parseInt(mappedEntries[key])];
                uniqueEntries.push(item);
            });
            console.log(uniqueEntries);
            return uniqueEntries;
        },
        
        buildTag(tagName, classes, innerHTML) {
            let containerDiv = document.createElement(tagName);
            containerDiv.className = classes;
            containerDiv.innerHTML = innerHTML;
            return containerDiv;
        },

        initLayout(adapter, eventEmitter) {
            // WPLAYER-239: Hiding this on safari as safari doesn't have quality feature
            if (Browser.currentBrowser().name === Browser.SAFARI) {
                this.hide();
                return false;
            }
            
            const videoQualitiesObj = this.modify(
                this.uniqueEntries(adapter.getAvailableVideoQualities()),
                this.addDisplayLabel
            );

            this.adapter = adapter;

            let btnSettings = document.querySelector('.video-quality-custom');
            if (!btnSettings) {
                btnSettings = this.addIcon();
            }

            emitter = eventEmitter;

            btnSettings.onclick = () => {
                const domCustom = safe.code(() => document.getElementsByClassName(videoQualityElemCustom));
                if (domCustom.length >= 1) {
                    this.toggle(domCustom[0]);
                    this.toggleClass('.video-quality-custom', 'is-active');
                }
            };

            const selectedVideoQualityLabel = videoQualitiesObj.filter(item => !!item.active);
            
            if (selectedVideoQualityLabel.length > 0) {
                this.persistUserSelection(adapter,
                    selectedVideoQualityLabel[0].quality_key,
                    selectedVideoQualityLabel[0].id
                );
            } else {
                this.persistUserSelection(adapter, 'auto');
            }

            this.render(template({
                videoQualityObj: videoQualitiesObj,
                qualityTitle: LanguageManager.get('quality_title'),
                qualityAuto: LanguageManager.get('quality_type_auto'),
                isAutoSelected: sessionStorage.getItem('video-quality') === 'auto'
            }));

            // Attach adapter to the events
            this.events(adapter);

            return true;
        },

        select(args) {
            const elem = args.el;
            const targetValue = elem.getAttribute('data-key');

            if (elem.classList.contains('is-selected')) {
                return false;
            }

            this.persistUserSelection(args.adapter, targetValue, elem.getAttribute('data-val'));

            Array.from(
                document.querySelectorAll('.video-quality-select')
            ).forEach(el => el.classList.remove('is-selected'));

            if (!elem.classList.contains('is-selected')) {
                elem.classList.add('is-selected');
            }

            return true;
        },

        toggleClass(selector, className) {
            const elem = safe.code(() => document.querySelector(selector));
            if (elem.classList.contains(className)) {
                elem.classList.remove(className);
            } else {
                elem.classList.add(className);
            }
            return elem;
        },

        setVideoQuality(adapter, value = 'auto') {
            console.log('Setting value to the adapter', value);
            return adapter.setVideoQuality(value);
        },

        events(adapter) {
            return Array.from(safe.code(() => document.querySelectorAll('.video-quality-select'))).map(el => {
                el.addEventListener('click', e => this.select({adapter: adapter, el: e.target}));
            });
        },

        addClass(selector, className) {
            const elem = safe.code(() => document.querySelector(selector));
            if (elem && !elem.classList.contains(className)) {
                elem.classList.add(className);
            }
            return elem;
        },

        removeClass(selector, className) {
            const elem = safe.code(() => document.querySelector(selector));
            if (elem && elem.classList.contains(className)) {
                elem.classList.remove(className);
            }
            return elem;
        },

        addIcon() {
            const btn = document.createElement('button');
            const oldCaptionsBtn = document.getElementsByClassName('bitdash-captions')[0];
            btn.setAttribute('type', 'button');
            btn.setAttribute('class', 'video-quality-custom');
            btn.setAttribute('data-state', 'video-quality');
            btn.innerHTML = 'Video Quality';
            
            const toolTip = document.createElement('div');
            toolTip.classList.add('bitdash-btns');
            toolTip.classList.add('bitdash-btns-video-selector');
            toolTip.setAttribute('data-tooltip', LanguageManager.get('tooltip_player_quality'));
            oldCaptionsBtn.parentNode.insertBefore(toolTip, oldCaptionsBtn);
            toolTip.appendChild(btn);
            this.hide(oldCaptionsBtn);
            return btn;
        },

        show(elem) {
            elem.classList.add('is-shown');
            elem.setAttribute('data-is-visible', '1');
            if (emitter) {
                emitter.emit('menu-shown', 'video-quality-selector');
            }
        },

        hide(elem) {
            if (!elem) {
                elem = elem || safe.code(() => document.getElementsByClassName(videoQualityElemCustom)[0]);
                this.removeClass('.video-quality-custom', 'is-active');

                if (!elem) {
                    return false;
                }
            }
            elem.classList.remove('is-shown');
            elem.removeAttribute('data-is-visible');
            if (emitter) {
                emitter.emit('menu-hidden', 'video-quality-selector');
            }
        },

        toggle(elem) {
            if (elem.getAttribute('data-is-visible') === '1') {
                this.hide(elem);
            } else {
                this.show(elem);
            }
        },
        
        persistUserSelection(adapter, dataVal = 'auto', valueId = null) {
            if (!sessionStorage && !sessionStorage.setItem) { return false; }

            const selection = sessionStorage.getItem('video-quality');

            if (selection !== dataVal) {
                console.log('Setting Item Value', dataVal);
                sessionStorage.setItem('video-quality', dataVal);
            }
            if (valueId) {
                this.setVideoQuality(adapter, valueId);
            } else {
                this.setVideoQuality(adapter, dataVal);
            }
        },

        clean(adapter) {
            this.setVideoQuality(adapter);
            DomUtils.destroyElementByType('class', videoQualityElemCustom);
        }
    };
})();



// WEBPACK FOOTER //
// ./src/modules/video_quality/video_quality.js